import { render } from "./StatusOnboardComponent.vue?vue&type=template&id=49635f78&scoped=true"
import script from "./StatusOnboardComponent.vue?vue&type=script&lang=js"
export * from "./StatusOnboardComponent.vue?vue&type=script&lang=js"

import "./StatusOnboardComponent.vue?vue&type=style&index=0&id=49635f78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49635f78"]])

export default __exports__